import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table, Container, Alert,
} from 'react-bootstrap';

import {
  getTypers,
  updateTyper,
  deleteTyper,
  createTyper,
} from '../../store/typers';

import ExistingTyperRow from './ExistingTyperRow';
import NewTyperRow from './NewTyperRow';

const TypersTable = () => {
  const dispatch = useDispatch();
  const typers = useSelector((store) => store.typers.typers);
  const error = useSelector((store) => store.typers.error);

  useEffect(() => {
    dispatch(getTypers());
  }, [dispatch]);

  const onCreate = async (name, password, enabled) => {
    dispatch(createTyper({ name, password, enabled }));
  };

  const onDelete = (id) => {
    dispatch(deleteTyper(id));
  };

  const onUpdate = (id, field, newValue) => {
    dispatch(updateTyper({ id, field, newValue }));
  };

  return (
    <Container>
      <Table size="sm">
        <thead>
          <tr>
            <th>id</th>
            <th>name</th>
            <th>password</th>
            <th>enabled</th>
            <th>Queries #</th>
            <th>action</th>
          </tr>
        </thead>
        <tbody>
          {typers.map((typer) => (
            <ExistingTyperRow
              typer={typer}
              key={typer.id}
              onUpdate={onUpdate}
              onDelete={onDelete}
            />
          ))}
          <NewTyperRow onCreate={onCreate} formId="new-typer" />
        </tbody>
      </Table>
      {error && <Alert variant="danger">{error}</Alert>}
    </Container>
  );
};

export default TypersTable;
